import React, { useState, useEffect } from "react";
import { FaBriefcase, FaGraduationCap, FaClock } from "react-icons/fa";
import styles from "./TimelineSection.module.css";

const timelineData = [
  {
    id: 1,
    side: "right",
    type: "education",
    title: "Advanced Statistics for Data Science Specialization",
    subtitle: "Johns Hopkins University",
    dateRange: "07.2025 - Present",
    details: ["Advanced Statistics for Data Science — Johns Hopkins University (Coursera). Statistical inference, hypothesis testing and experimental design for DS"],
  },
  {
  
    id: 2,
    side: "left",
    type: "education",
    title: "GenAI Basics - How LLMs Work",
    subtitle: "Duke University",
    dateRange: "05.2025 - 05.2025",
    details: ["Certified in Fundamentals of Databricks"],
  },
  {
    id: 3,
    side: "right",
    type: "education",
    title: "GenAI For Business Analysis: Fine-Tuning LLMs",
    subtitle: "Coursera Project Network",
    dateRange: "05.2025 - 05.2025",
    details: ["Certified in Fundamentals of Databricks"],
  },
  {
    id: 4,
    side: "left",
    type: "education",
    title: "Introduction to CRM with HubSpot",
    subtitle: "Coursera Project Network",
    dateRange: "05.2025 - 05.2025",
    details: ["Certified in Fundamentals of Databricks"],
  },
  {
    id: 5,
    side: "right",
    type: "education",
    title: "Databricks Fundamentals Accreditation",
    subtitle: "Databricks",
    dateRange: "05.2025 - 05.2025",
    details: ["Certified in Fundamentals of Databricks"],
  },
  {
    id: 7,
    side: "left",
    type: "work-experience",
    title: "Retail Floor Customer Sales Rep",
    subtitle: "Nisa Local, Farnham, Surrey",
    dateRange: "09.2024 - 02.2025",
    details: [
      "Performed various store operations for closing procedures, product display management.",
      "Managed store inventory by directing routine stock control procedures to maximise sales opportunities.",
      "Guaranteed delivery of first-class customer service, coaching team members to produce positive outcomes.",
      "Effectively assigned daily responsibilities to team members, ensuring smooth operations and optimal task completion across the store.",
    ],
  },
  {
    id: 7,
    side: "right",
    type: "work-experience",
    title: "Freelance Automation & Web Developer",
    subtitle: "Freelance",
    dateRange: "03.2024 - 03.2025",
    details: [
      "Built responsive WordPress sites with Elementor, WooCommerce & CRM integrations.",
      "Automated workflows reducing manual data entry by 25%.",
      "Created automation scripts removing repetitive tasks.",
      "Developed data extraction and cleaning tools to support client workflows.",
    ],
  },
  {
    id: 8,
    side: "left",
    type: "work-experience",
    title: "Software Engineer - ML Automation",
    subtitle: "Vision4ce (Chess-Dynamics), Reading",
    dateRange: "09.2023 - 10.2024",
    details: [
      "Programming: Python (data scraping, automation, testing), Shell scripting (cluster scripts, data management).",
      "Data Engineering: Data scraping, database management, data indexing/triage with automated pipelines.",
      "Machine Learning: Implemented models (e.g., ResNet50, INT8 calibration), classification systems, cluster analysis.",
      "Deep Learning: Neural networks (ResNet50, YOLO), Darknet, TensorRT engine creation.",
      "DevOps: Apache Airflow (workflow management), CI DAG testing, automation scripts.",
      "Image Processing: Automated labelling, patch creation, and dataset organization by classification.",
      "Software Development: API creation, testing frameworks, Git version control.",
      "Other Skills: Docker (isolated environments), JSON/XML (configurations, labelling).",
    ],
  },
  {
    id: 9,
    side: "right",
    type: "education",
    title:
      "Bachelor of Engineering - Electronic Engineering With Placement Training Year & Foundation Year",
    subtitle: "University of Surrey, Guildford",
    dateRange: "09.2020 - 07.2025",
    details: [
      "Grade : 2:1",
      "Modules: \nMachine Learning, \nData Science, \nComputer Vision & Pattern Recognition, \nRobotics, \nEmbedded Systems, \nPower Electronics, \nNanoscience & Nanoparticles, \nSemiconductors & Optoelectronics",
    ],
  },
  {
    id: 10,
    side: "left",
    type: "education",
    title: "A-Levels",
    subtitle: "Ernest Bevin College, London",
    dateRange: "09.2018 - 07.2020",
    details: [
      "Maths (B), Physics (C), Computer Science (C)",
      "Member of Cricket",
    ],
  },
  {
    id: 11,
    side: "right",
    type: "work-experience",
    title: "Second Line Help Desk",
    subtitle: "NHS, London",
    dateRange: "11.2018 - 11.2018",
    details: [
      "Technical troubleshooting",
      "IT infrastructure",
      "Customer service",
      "Documentation and reporting",
      "Participated in fire training, CPR training, and first aid to ensure safety in workplace.",
      "Managed multiple clients calls per day",
    ],
  },
  {
    id: 12,
    side: "left",
    type: "work-experience",
    title: "Help Desk",
    subtitle: "Kaplan, London",
    dateRange: "10.2018 - 10.2018",
    details: [
      "Technical troubleshooting",
      "Customer service",
      "IT infrastructure",
      "Time management",
      "Gained insight into IT support system and cyber security.",
      "Shadowed experts to learn different ways of solving IT-related issues",
      "Managed multiple clients calls per day",
    ],
  },
  {
    id: 13,
    side: "right",
    type: "work-experience",
    title: "Royal Marines Cadets",
    subtitle: "Ernest Bevin College, London",
    dateRange: "09.2015 - 07.2018",
    details: [
      "Developed teamwork, discipline and leadership.",
    ],
  },  
  {
    id: 14,
    side: "left",
    type: "education",
    title: "GCSE",
    subtitle: "Ernest Bevin College, London",
    dateRange: "09.2013 - 07.2018",
    details: [
      "Maths (7), English Language (4), English Literature (5), Combined Science (6,5),Geography (4), Business Studies (D)",
      "Member of Cricket, CCF, Football",
    ],
  },
];

export default function TimelineSection() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={styles.timelineSection} id="timeline">
      <div className={styles.heading}>
        <FaClock className={styles.headingIcon} />
        <h3>TIMELINE</h3>
      </div>

      {isMobile ? <MobileTimeline /> : <DesktopTimeline />}
    </section>
  );
}

function DesktopTimeline() {
  return (
    <div className={styles.timelineContainer}>
      {timelineData.map((item) => (
        <div key={item.id} className={styles.row}>
          {/* left column => if side=left, show the card */}
          <div className={styles.leftCol}>
            {item.side === "left" && <TimelineCard item={item} />}
          </div>

          {/* center column => line + dot in the middle on desktop */}
          <div className={styles.centerCol}>
            <div className={styles.dot} />
          </div>

          {/* right column => if side=right, show the card */}
          <div className={styles.rightCol}>
            {item.side === "right" && <TimelineCard item={item} />}
          </div>
        </div>
      ))}
    </div>
  );
}

function MobileTimeline() {
  return (
    <div className={styles.timelineContainer}>
      {timelineData.map((item) => (
        <div key={item.id} className={styles.row}>
          {/* center column => line + dot in the middle on desktop */}
          <div className={styles.centerCol}>
            <div className={styles.dot} />
          </div>

          {/* right column => if side=right, show the card */}
          <div className={styles.rightCol}>
            {(item.side === "right" && <TimelineCard item={item} />) ||
              (item.side === "left" && <TimelineCard item={item} />)}
          </div>
        </div>
      ))}
    </div>
  );
}

function TimelineCard({ item }) {
  const { type, title, subtitle, dateRange } = item;
  let IconComp = FaBriefcase;
  if (type === "education") {
    IconComp = FaGraduationCap;
  }

  const [expanded, setExpanded] = useState(false);

  const toggleDesc = () => setExpanded(!expanded);

  return (
    <div className={styles.cardLink}>
      <div className={styles.card}>
        <div className={styles.cardIcon}>
          <IconComp />
        </div>
        <h4 className={styles.cardTitle}>{title}</h4>
        <p className={styles.cardSubtitle}>{subtitle}</p>
        <p className={styles.cardDate}>{dateRange}</p>
        {/* Show/hide details */}
        {expanded && (
          <ul className={styles.detailsList}>
            {item.details.map((detail, idx) => (
              <DetailItem key={idx} text={detail} />
            ))}
          </ul>
        )}

        {/* Toggle link */}
        <p className={styles.toggleDesc} onClick={toggleDesc}>
          {expanded ? "Hide Description" : "Show Description"}
        </p>
      </div>
    </div>
  );
}

function DetailItem({ text }) {
  // If it doesn't contain newlines, render normally
  if (!text.includes("\n")) {
    return <li>{text}</li>;
  }

  // Split into lines, trim, drop empties
  const lines = text
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  // Parent label (e.g. "Modules:")
  const parentRaw = lines[0] ?? "";
  const parent = parentRaw.replace(/:\s*$/, ""); // remove trailing ":"

  // Children lines, also split commas so you can keep your current format
  const children = lines
    .slice(1)
    .flatMap((l) => l.split(","))
    .map((l) => l.trim())
    .filter(Boolean);

  return (
    <li>
      {parent}
      {children.length > 0 && (
        <ul className={styles.subDetailsList}>
          {children.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>
      )}
    </li>
  );
}
